import { useDispatch, useSelector } from "react-redux";
import FeedbackTable from "../../components/feedbackTable/FeedbackTable";
import { getAllFeedbacks } from "./actions";
import React from "react";

/**
 * @function Feedback
 * @description for Feedback
 * @returns JSX for Feedback
 */
const Feedback = () => {
  const dispatch = useDispatch();
  const { pageNo, limit, sortBy, sortOrder, status } = useSelector(
    (state) => state.FeedbackReducer
  );

  React.useEffect(() => {
    dispatch(getAllFeedbacks());
  }, [pageNo, limit, sortBy, sortOrder, status]);

  return (
    <div>
      <FeedbackTable />
    </div>
  );
};

export default Feedback;
